import { all, call, put, takeLatest, select } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

var i,
    j = 0;

// WATCHER SAGA
export default function* () {
    yield all([
        takeLatest(
            actionTypes.DASHBOARD_ASSETS_PER_BRANCH_REQUEST,
            getBranchesRequest
        ),
        takeLatest(actionTypes.BRANCH_LIST_REQUEST, getBranchListRequest),
        takeLatest(
            actionTypes.EXCLUSION_REASON_REQUEST,
            getExclusionReasonsRequest
        ),
        takeLatest(actionTypes.STOCK_DATA_REQUEST, getStockDataRequest)
    ]);
}
// WORKER SAGA
function* getBranchesRequest(action) {
    const { id } = yield select((state) => state.userOrganisations.item);

    const url = `${config.api.paths.auditSummary}?organisation=${id}`;

    try {
        const res = yield call(http.authorized.get, url);

        const assetsPerBranch = [];
        /*
        for (i=0; i<res.data.length; i++) {
            assetsPerBranch.push(res.data[i].name);            
        }
        */
       
        //state.assetsPerBranch = assetsPerBranch
        //let x = res.map(id=>(<li>{res.data[id].name}</li>))
        //yield put(actionCreators.getBranchesSuccess(assetsPerBranch))
        yield put({
            type: actionTypes.DASHBOARD_ASSETS_PER_BRANCH_SUCCESS,
            payload: res.data.auditData
        });
    } catch (error) {
        //console.log(error);
        logToSentry("On dashboard assets per branch get:", { error });
        yield put(actionCreators.getBranchesFailure(error));
    }
}
function* getBranchListRequest(action) {
    const { id } = yield select((state) => state.userOrganisations.item);

    const url = `${config.api.paths.branches}?organisation=${id}`;

    try {
        const res = yield call(http.authorized.get, url);
        
        const assetsPerBranch = [];

        for (i = 0; i < res.data.length; i++) {
            assetsPerBranch.push(res.data[i]);
        }
        yield put({
            type: actionTypes.BRANCH_LIST_SUCCESS,
            payload: { assetsPerBranch }
        });
    } catch (error) {
        console.log("EROROR IN BRANCH LIST");
        logToSentry("On branch list get:", { error });
        yield put(actionCreators.getBranchListFailure(error));
    }
}

function* getExclusionReasonsRequest(action) {
    const url = `${config.api.paths.exclusionReasons}`;

    try {
        const res = yield call(http.authorized.get, url);
        const exclusionreasons = [];

        for (i = 0; i < res.data.length; i++) {
            exclusionreasons.push(res.data[i]);
        }
        yield put({
            type: actionTypes.EXCLUSION_REASON_SUCCESS,
            payload: { exclusionreasons }
        });
    } catch (error) {
        console.log("EROROR IN BRANCH LIST");
        logToSentry("On exclusion reasons get:", { error });
        yield put(actionCreators.getExclusionReasonsFailure(error));
    }
}

function* getStockDataRequest(action) {
    const { id } = yield select((state) => state.userOrganisations.item);

    const url = `${config.api.paths.branchStockSummary}?organisation=${id}`;

    try {
        const res = yield call(http.authorized.get, url);
        
        const stockdatax = [];

        for (i = 0; i < res.data.length; i++) {
            stockdatax.push(res.data[i]);
        }

        //state.assetsPerBranch = assetsPerBranch
        //let x = res.map(id=>(<li>{res.data[id].name}</li>))
        //yield put(actionCreators.getBranchesSuccess(assetsPerBranch))

        yield put({
            type: actionTypes.STOCK_DATA_SUCCESS,
            payload: { stockdatax }
        });
    } catch (error) {
        console.log("EROROR IN GET STOCK");
        logToSentry("On stock data get:", { error });
        yield put(actionCreators.getStockDataFailure(error));
    }
}
